import {
  ITableDataRow,
  ITableFunction,
  ITableParams,
} from 'matrix-requirements-sdk/client';

// Function signature is ITableFunction.
export function tableMathExample(
  table: ITableDataRow[],
  parameterJson: ITableParams,
) {
  return '';
}
